import { Box } from '@chakra-ui/react';

import { AnimatedCollapseProps } from './animated-collapse.props';

export const AnimatedCollapse = ({ isOpen, children, ...props }: AnimatedCollapseProps) => (
    <Box
        display={'grid'}
        gridTemplateRows={isOpen ? '1fr' : '0fr'}
        opacity={isOpen ? 1 : 0}
        transform={isOpen ? 'translateY(0)' : 'translateY(-8px)'}
        pointerEvents={isOpen ? 'auto' : 'none'}
        transition={
            'grid-template-rows .5s ease, opacity .5s ease, transform .5s ease, margin .5s ease'
        }
        {...props}
    >
        <Box overflow={'hidden'}>{children}</Box>
    </Box>
);
